import httpClient from 'api/httpClient';
import publicHttpClient from 'api/publicHttpClient';
import { AuthBody } from 'models/AuthBody';
import {
  ShareableLinkMainInfo,
  ShareableLinkSecurityInfo,
} from 'models/ShareableLink';

function getEmail(shareableLinkId: string, emailToken: string) {
  return publicHttpClient.get<{ email: string }>(
    `shareable-links/${shareableLinkId}/email`,
    {
      params: { emailToken },
    },
  );
}

function getSecurityInfo(shareableLinkId: string) {
  return publicHttpClient.get<ShareableLinkSecurityInfo>(
    `shareable-links/${shareableLinkId}/security-info`,
  );
}

function authorization(
  shareableLinkId: string,
  firstName: string,
  email: string,
  password: string,
  passcode?: string,
  agreeToTC?: boolean,
) {
  return publicHttpClient.post<AuthBody>(
    `shareable-links/${shareableLinkId}/authorization`,
    {
      firstName,
      email,
      password,
      passcode,
      agreeToTC,
    },
  );
}

function getShareableLinkMainInfo(shareableLinkId: string) {
  return httpClient.get<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/main-info`,
  );
}

function requestAccessForExpiredLink(shareableLinkId: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-access-for-expired`,
  );
}

function requestAccess(shareableLinkId: string) {
  return httpClient.post(`shareable-links/${shareableLinkId}/request-access`);
}

function requestAccessReminder(shareableLinkId: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-access-reminder`,
  );
}

function requestPassword(shareableLinkId: string, email: string) {
  return publicHttpClient.post(
    `shareable-links/${shareableLinkId}/request-password`,
    { email },
  );
}

function requestPasswordReminder(shareableLinkId: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-password-reminder`,
  );
}

function confirmPassword(
  shareableLinkId: string,
  password: string,
  agreeToTC?: boolean,
) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/confirm-password`,
    {
      password,
      agreeToTC,
    },
  );
}

// when user request password for SL
function sendPassword(shareableLinkId: string, emailToken: string) {
  return publicHttpClient.post(
    `shareable-links/${shareableLinkId}/send-password`,
    {
      emailToken,
    },
  );
}

function getNDADocusignUrl(shareableLinkId: string) {
  return httpClient.get<{ url: string }>(
    `data-room-ndas/shareable-links/${shareableLinkId}/docusign-url`,
  );
}

function acceptTermsAndConditions(shareableLinkId: string) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/accept-terms-and-conditions`,
  );
}

function rejectTermsAndConditions(shareableLinkId: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/reject-terms-and-conditions`,
  );
}

function getAccessBeforeDRaccess(shareableLinkId: string) {
  return httpClient.post(`shareable-links/${shareableLinkId}/access`);
}

export default {
  getEmail,
  getSecurityInfo,
  authorization,
  getShareableLinkMainInfo,
  requestAccessForExpiredLink,
  requestAccess,
  requestAccessReminder,
  requestPassword,
  requestPasswordReminder,
  confirmPassword,
  sendPassword,
  getNDADocusignUrl,
  acceptTermsAndConditions,
  rejectTermsAndConditions,
  getAccessBeforeDRaccess,
};
